var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-modal",
                  {
                    ref: "addProjectModal",
                    attrs: {
                      id: "modal-add-milestones",
                      "ok-only": "",
                      "ok-title": "Add",
                      centered: "",
                      size: "lg",
                      title: "Add Milestones",
                      "hide-footer": true,
                    },
                  },
                  [
                    _c("AddMilestone", {
                      on: { milestoneAdded: _vm.closeAddProjectModal },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.modal-add-milestones",
                        modifiers: { "modal-add-milestones": true },
                      },
                    ],
                    attrs: { variant: "primary" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _vm._v(" Add Milestones "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.milestones.length === 0 && !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("h2", [_vm._v("No Milestones available")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "d-block" },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-between" },
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Filter",
                            "label-cols-sm": "3",
                            "label-align-sm": "right",
                            "label-size": "sm",
                            "label-for": "filterInput",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "filterInput",
                                  type: "search",
                                  placeholder: "Type to Search",
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { disabled: !_vm.filter },
                                      on: {
                                        click: function ($event) {
                                          _vm.filter = ""
                                        },
                                      },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              responsive: "",
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              items: _vm.milestones,
                              fields: _vm.fields,
                              filter: _vm.filter,
                              "filter-included-fields": _vm.filterOn,
                            },
                            on: { filtered: _vm.onFiltered },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(avatar)",
                                  fn: function (data) {
                                    return [
                                      _c("b-avatar", {
                                        attrs: { src: data.value },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(progress_status)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "b-badge",
                                        {
                                          attrs: {
                                            variant:
                                              _vm.progress_status[1][
                                                data.value
                                              ],
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.progress_status[0][
                                                  data.value
                                                ]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(actions)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "b-dropdown",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            variant: "link",
                                            "toggle-class": "p-0",
                                            "no-caret": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        icon: "MoreVerticalIcon",
                                                        size: "16",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.modal-edit-milestones",
                                                  modifiers: {
                                                    "modal-edit-milestones": true,
                                                  },
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.EditTask(data.item)
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "EditIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Edit")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteProject(
                                                    data.item.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "TrashIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                          data.item.status !== "NOTSTARTED" &&
                                          data.item.status !== "REMOVED"
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  attrs: {
                                                    to: {
                                                      path:
                                                        "/projectmanagement/tasks-list/" +
                                                        data.item.projectId +
                                                        "/" +
                                                        data.item.id,
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: {
                                                      icon: "FileTextIcon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle ml-50",
                                                    },
                                                    [_vm._v("Tasks")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewMilestoneDocument(
                                                    data.item.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: {
                                                  icon: "PaperclipIcon",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Documents")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2358277167
                            ),
                          }),
                          _c(
                            "b-modal",
                            {
                              ref: "editProjectModal",
                              attrs: {
                                id: "modal-edit-milestones",
                                "ok-only": "",
                                "ok-title": "Edit",
                                centered: "",
                                size: "lg",
                                title: "Edit Milestones",
                                "hide-footer": true,
                              },
                            },
                            [
                              _c("EditMilestones", {
                                attrs: { milestone: _vm.currentTask },
                                on: {
                                  MilestoneUpdated: _vm.closeEditProjectModal,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-modal",
                            {
                              ref: "modal-view-document",
                              attrs: {
                                id: "modal-view-document",
                                "ok-only": "",
                                "ok-title": "View",
                                centered: "",
                                size: "lg",
                                title: "View Documents",
                                "hide-footer": true,
                              },
                            },
                            [
                              _c("DocumentUpload", {
                                attrs: { documentDetails: _vm.documentDetails },
                                on: {
                                  deleteFile: _vm.deleteFile,
                                  downloadFile: _vm.downloadFile,
                                  uploadFiles: _vm.uploadFiles,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.milestones.length,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }